import { useViewPreference, GROUPING_PREFERENCE } from '@atlassian/jira-business-preferences';
import type { GroupByFieldId } from '../../services/get-item-groups/types';

export const useGroupBy = () => {
	const [groupByFieldId, setGroupBy] = useViewPreference(GROUPING_PREFERENCE);
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return [groupByFieldId as GroupByFieldId, setGroupBy] as const;
};
